const tokenStorageKey = 'auth-token'
export function getStoredAuthToken(): string | undefined {
  return localStorage.getItem(tokenStorageKey)
}
export function setStoredAuthToken(token: string): void {
  localStorage.setItem(tokenStorageKey, token || '')
}

export function getActiveAuthType(): 'msal' {
  return 'msal'
}

export function clearLocalStorage(): void {
  localStorage.clear()
}

export function getApiUrl(): string {
  return (window as any).REACT_APP_API_URL_AZURE_AD || ''
}
